import { render } from "./EventNavSection.vue?vue&type=template&id=5497e0d8"
import script from "./EventNavSection.vue?vue&type=script&lang=js"
export * from "./EventNavSection.vue?vue&type=script&lang=js"

import "./EventNavSection.vue?vue&type=style&index=0&id=5497e0d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__